<template>
  <section class="generic-dropdown"
           :tabindex="0"
           v-on:keypress.space.enter="toggleActive">
    <div :role="idAndName + ' option'"
         class="dropdown cursor-pointer unselectable floating-label"
         :aria-selected="active"
         :id="idAndName"
         :class="{'is-active' : active, 'dropdown_stemexpo' : this.isStemExpo, 'is-up' : isUp, 'disabled': isDisabled}"
         :style="selectedHeightComputed"
         >
      <div v-if="active" class="outside" @click="active = false" />
      <div class="dropdown-trigger" @click="!isDisabled ? active = !active: ''" :class="{'customMargin': $isEngCom}">
        <span class="placeholder-text" :class="{'placeholder-top': !showPlaceholderText }">{{ placeholder }}</span>
        <span v-if="!showPlaceholderText"
              ref="selectedValue" class="dropdown-textOverflow"
              :class="{'dropdown-trigger_text': this.isStemExpo(), 'isAuditoriumStoryInput': isAuditoriumStory, 'selected-value-webinar-modal' : isWebinarSignupModal, 'selected-value' : !isWebinarSignupModal}">
          <span v-if="displayItemValue(value)">{{ displayItemValue(value) }}</span>
        </span>
        <span class="icon is-small trigger is-pulled-right"
              :class="{'trigger_stemexpo': this.isStemExpo()}">
          <i :class="{'fal fa-angle-down' : !active, 'fal fa-angle-up' : active}"
             style="margin-right: 10px; margin-top: 5px"
             aria-hidden="true"/>
        </span>
      </div>
      <div class="dropdown-menu"
           :class="{'dropdown-menu_stemexpo': this.isStemExpo()}"
           id="dropdown-menu"
           role="menu">
        <!--  Check env & path    -->
        <div class="dropdown-content"
             :class="{'dropdown-content_stemexpo': this.isStemExpo()}">
          <div aria-hidden="true"
               @focus="selectFirstElement(items[0])"
               tabindex="0" />
          <a :ref="item" class="dropdown-item dropdown-textOverflow" style="font-size: 12px"
             :tabindex="0"
             v-for="item in items"
             :key="item.id"
             @keypress.enter.space.esc="getPathExpo(env,path) ? selectExpo(item) : select(item)"
             @click="getPathExpo(env,path) ? selectExpo(item) : select(item); toggleActive() ">
            {{ displayItemValue(item) }}
          </a>
          <div aria-hidden="true"
               @focus="selectFirstElement(items[0])"
               tabindex="0" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import genericComponentMixin from './mixin'

export default {
  name: 'genericDropdown',
  props: {
    value: [Object, String, Boolean],
    items: Array,
    placeholder: String,
    inputName: String,
    error: String,
    width: String,
    env: String,
    path: String,
    isUp: Boolean,
    isDisabled: Boolean,
    isWebinarSignupModal: Boolean,
    heightAdjustment: Number
  },
  mixins: [genericComponentMixin],
  data: function () {
    return {
      active: false,
      selectedHeight: 'auto'
    }
  },
  computed: {
    showPlaceholderText: function () {
      return this.value === null || this.value === undefined || this.value === ''
    },
    selectedHeightComputed: function () {
      if (!this.showPlaceholderText) {
        return `height: ${this.selectedHeight + 30 + this.heightAdjustment}px`
      }
      return `height: ${this.selectedHeight + 20 + this.heightAdjustment}px`
    },
    isAuditoriumStory: function () {
      return this.$route.name === 'viewAuditoriumStory'
    }
  },
  mounted: function () {
    this.getHeight()
  },
  methods: {
    toggleActive: function () {
      this.active = !this.active
    },
    displayItemValue: function (item) {
      if (item === null || item === '') {
        return
      }
      if (typeof item === 'object') {
        if (this.$route.path.includes('stem-expo')) {
          if (item.user.fullName) {
            return item.user.fullName
          } else {
            return item.user.userName ? item.user.userName : item.title
          }
        }
        if (this.$route.path.includes('auditoriumStory')) {
          if (item.language) {
            return item.language
          }
        }
        // not all uses for the dropdown across the partner has language options
        // i.e the events dropdown in the navbar admin tools
        if ((this.$isYSC || this.$isOhioScience) && item.values?.en) {
          switch (this.$i18n.locale) {
            case 'fr':
              return item.values.fr || item.values.en // default to English if French values are missing
            default:
              return item.values.en
          }
        }

        return item.name ? item.name : item.title ? item.title : item.details && item.details.title
          ? item.details.title : item.question ? item.question : item.value ? item.value : item.id === 0 ? '' : item.label ? item.label : item.id
      }

      return item
    },
    select: function (item) {
      this.$emit('input', item)
      this.active = false
      this.toggleActive()
      this.getHeight()
    },
    getPathExpo: function (env, path) {
      if (this.$props.env) {
        return this.$props.env.toLowerCase() === 'ysc' && this.$props.path.replace('/', '') === 'stem-expo'
      }
    },
    selectExpo: function (item) {
      this.$emit('input', item)
      this.active = false
      const url = '/expobooth/' + item.id
      this.$router.push(url)
    },
    isStemExpo: function () {
      return this.$route.path.replace('/', '') === 'stem-expo'
    },
    selectFirstElement: function (input) {
      this.$refs[input][0].focus()
    },
    getHeight: function () {
      this.$nextTick(() => {
        this.selectedHeight = this.$refs.selectedValue?.clientHeight
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .isAuditoriumStoryInput {
    margin-top: 13px
  }
  .generic-dropdown {
    margin: 0 auto 0.75rem;
    width: 100%;
    min-height: 45px;
  }
  .dropdown {
    text-align: left;
    height: 100%;
    border: 1.5px solid #DCDCDC;
    border-radius: 4px;
    font-size: 0.85rem;
    font-family: 'Roboto';
    align-items: center;
    width: 100%;
    &_stemexpo{
      background-color: white;
      color: black;
    }
    .dropdown-trigger {
      width: 100%;
      height: 100%;
      margin-bottom: 0;
      justify-content: space-between;
      display: flex;
      &_text {
        font-size: 0.75em;
      }
      .trigger {
        margin-top: .8rem;
        font-size: 1.3rem;
        color: $primary;
        &_stemexpo {
          padding-top: 0 !important;
        }
      }
    }
    &.is-active {
      border: 1px solid lighten($primary, 10%);
      box-shadow: 0 0 0 0.125em lighten($primary, 40%);
    }
  }
  .dropdown-content {
    background-color: white;
    width: 100%;
    &_stemexpo {
      border: 1px solid #c9c9c9;
      background-color: white !important;
      margin-top: -3px !important;
      left: -1px !important;
    }
  }
  .dropdown-menu {
    max-height: 9rem;
    width: 100%;
    overflow: auto;
    background-color: white;
    border: 1px solid #c9c9c9;
    &_stemexpo {
      background-color: transparent !important;
    }
    @include touch {
      max-height: 7rem;
    }
  }
  .is-up {
    .dropdown-menu {
      margin-top: 0;
      margin-bottom: 0.2rem;
    }
  }
  .dropdown-textOverflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
  }

  .outside {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0px;
    left: 0px;
  }
  .dropdown-menu{
    min-width: 100%;
  }
  .floating-label {
    position: relative;
    .placeholder-text {
      top: 0;
      position: absolute;
      bottom: 5%;
      left: 0%;
      color: $grey-light;
      transition: all .3s ease;
      font-size: 0.85rem;
      padding: 0.5rem
    }
    .dropdown-trigger {
      transition: all .1s ease;
      display: block;
      position: relative;
      display: block;
      min-height: 45px;
    }
    .placeholder-top {
      top: 0%;
      opacity: .8;
      font-size: 0.75rem;
    }
    .selected-value-webinar-modal {
      position: absolute;
      line-height: 13.5px;
      padding-top: 5.5%;
      margin-left: 8px;
      color: #363636;
      max-width: 310px;
      width: 100%;
      top: 20%;
    }
    .selected-value {
      position: absolute;
      line-height: 13.5px;
      padding-top: 2.5%;
      margin-left: 8px;
      color: #363636;
      max-width: 310px;
      width: 100%;
      top: 20%;
      @include mobile {
        padding-top: 2.5%;
      }
    }
    &.disabled {
      border-color: #F2F2F2;
      -webkit-box-shadow: none;
      box-shadow: none;
      cursor: not-allowed;
      .selected-value {
        color: #7a7a7a;
      }
    }
  }
  .personal-info-section .floating-label .selected-value {
    line-height: 20px !important;
    padding-top: 1.1% !important;
  }
  .customMargin{
   margin-bottom: 0.5rem !important;
  }

</style>
